module.exports = __webpack_public_path__ + "img/activities-workshop.6d535d25.jpg";